import CategoryCarousel from "./CategoryCarousel";

export default CategoryCarousel;
